<template>
	<div class="row mt-5 text-center">
		<div class="col-lg-12">
			<p>Εάν μπορείς να διαβάσεις αυτό το μήνυμα πρέπει<br>να ακούσεις το podcast μου, <a href="https://greekinthebox.com" target="_blank">Greek In The Box</a></p>
			<p class="mt-5">Copyright © {{ new Date().getFullYear() }} | <b>Antonios Tsamourtzis</b> | All Rights Reserved.</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer'
	}
</script>
